var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotepadBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2405 9.35033C17.2405 9.15049 17.1618 8.95868 17.0214 8.81644C16.881 8.67419 16.6903 8.59296 16.4905 8.59033H7.49047C7.2889 8.59033 7.0956 8.6704 6.95307 8.81293C6.81054 8.95546 6.73047 9.14877 6.73047 9.35033C6.73047 9.5519 6.81054 9.74521 6.95307 9.88773C7.0956 10.0303 7.2889 10.1103 7.49047 10.1103H16.4905C16.6903 10.1077 16.881 10.0265 17.0214 9.88423C17.1618 9.74198 17.2405 9.55018 17.2405 9.35033Z",
    fill: "url(#paint0_linear_406_14052)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.751 14.1003C11.751 13.9005 11.6723 13.7087 11.532 13.5664C11.3916 13.4242 11.2008 13.343 11.001 13.3403H7.55102C7.34945 13.3403 7.15614 13.4204 7.01361 13.5629C6.87109 13.7055 6.79102 13.8988 6.79102 14.1003C6.79102 14.3019 6.87109 14.4952 7.01361 14.6377C7.15614 14.7803 7.34945 14.8603 7.55102 14.8603H11.001C11.2008 14.8577 11.3916 14.7765 11.532 14.6342C11.6723 14.492 11.751 14.3002 11.751 14.1003Z",
    fill: "url(#paint1_linear_406_14052)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34961 5.4301C8.1507 5.4301 7.95993 5.35108 7.81928 5.21043C7.67863 5.06978 7.59961 4.87901 7.59961 4.6801V2.8501C7.59961 2.65119 7.67863 2.46042 7.81928 2.31977C7.95993 2.17912 8.1507 2.1001 8.34961 2.1001C8.54852 2.1001 8.73929 2.17912 8.87994 2.31977C9.02059 2.46042 9.09961 2.65119 9.09961 2.8501V4.6801C9.09961 4.87901 9.02059 5.06978 8.87994 5.21043C8.73929 5.35108 8.54852 5.4301 8.34961 5.4301Z",
    fill: "url(#paint2_linear_406_14052)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6505 5.4301C15.5516 5.43144 15.4535 5.41296 15.3619 5.37575C15.2703 5.33853 15.187 5.28334 15.1171 5.21342C15.0472 5.14351 14.992 5.0603 14.9548 4.96869C14.9176 4.87709 14.8991 4.77896 14.9005 4.6801V2.8501C14.9005 2.65119 14.9795 2.46042 15.1201 2.31977C15.2608 2.17912 15.4515 2.1001 15.6505 2.1001C15.8494 2.1001 16.0401 2.17912 16.1808 2.31977C16.3214 2.46042 16.4005 2.65119 16.4005 2.8501V4.6801C16.4005 4.87901 16.3214 5.06978 16.1808 5.21043C16.0401 5.35108 15.8494 5.4301 15.6505 5.4301Z",
    fill: "url(#paint3_linear_406_14052)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7794 22.0002V18.1102C14.7551 17.7435 14.805 17.3756 14.9262 17.0287C15.0475 16.6817 15.2375 16.3628 15.485 16.0911C15.7324 15.8193 16.0322 15.6004 16.3663 15.4473C16.7005 15.2942 17.0621 15.2102 17.4294 15.2002H21.2394L14.7794 22.0002Z",
    fill: "url(#paint4_linear_406_14052)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.2803 21.9999V18.1099C13.2576 17.5465 13.3475 16.9842 13.5447 16.4559C13.742 15.9276 14.0427 15.444 14.4291 15.0333C14.8156 14.6227 15.28 14.2932 15.7954 14.0643C16.3107 13.8353 16.8665 13.7115 17.4303 13.6999H21.1803V9.14994C21.1816 8.4334 21.0416 7.72362 20.7683 7.06125C20.495 6.39887 20.0938 5.79688 19.5876 5.28974C19.0814 4.7826 18.4801 4.38027 17.8183 4.10575C17.1564 3.83124 16.4469 3.68994 15.7303 3.68994H8.27032C7.55378 3.68994 6.84426 3.83124 6.18238 4.10575C5.52051 4.38027 4.91926 4.7826 4.41305 5.28974C3.90684 5.79688 3.5056 6.39887 3.2323 7.06125C2.95901 7.72362 2.81901 8.4334 2.82032 9.14994V16.5399C2.81901 17.2565 2.95901 17.9663 3.2323 18.6286C3.5056 19.291 3.90684 19.893 4.41305 20.4001C4.91926 20.9073 5.52051 21.3096 6.18238 21.5841C6.84426 21.8586 7.55378 21.9999 8.27032 21.9999H13.2703H13.2803Z",
    fill: "url(#paint5_linear_406_14052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14052",
    x1: 6.73047,
    y1: 9.35033,
    x2: 17.2405,
    y2: 9.35033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14052",
    x1: 6.79102,
    y1: 14.1003,
    x2: 11.751,
    y2: 14.1003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_14052",
    x1: 7.59961,
    y1: 3.7651,
    x2: 9.09961,
    y2: 3.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_14052",
    x1: 14.9004,
    y1: 3.76513,
    x2: 16.4005,
    y2: 3.76513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_406_14052",
    x1: 14.7734,
    y1: 18.6002,
    x2: 21.2394,
    y2: 18.6002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_406_14052",
    x1: 2.82031,
    y1: 12.8449,
    x2: 21.1803,
    y2: 12.8449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepadBookmark);
export default __webpack_public_path__ + "static/media/notepad-bookmark.052f1ae8401fea7aa7b8d8f8b2f03efe.svg";
export { ForwardRef as ReactComponent };